export enum InfoDialog {
  MAPP,
  EAN,
}
export enum MAPPStatus {
  SUCCESS = "SUCCESS",
  ERROR = "ERROR",
  WARNING = "WARNING",
  RED = "RED",
  GREEN = "GREEN",
  YELLOW = "YELLOW",
}
